import { jsx, jsxs } from "react/jsx-runtime";
import { Input, Label, Switch, XStack, YStack } from "tamagui";
function LabelDemo() {
  return /* @__PURE__ */ jsxs(YStack, { padding: "$3", minWidth: 300, space: "$4", children: [
    /* @__PURE__ */ jsxs(XStack, { alignItems: "center", space: "$4", children: [
      /* @__PURE__ */ jsx(Label, { width: 90, htmlFor: "name", children: "Name" }),
      /* @__PURE__ */ jsx(Input, { flex: 1, id: "name", defaultValue: "Nate Wienert" })
    ] }),
    /* @__PURE__ */ jsxs(XStack, { alignItems: "center", space: "$4", children: [
      /* @__PURE__ */ jsx(Label, { width: 90, htmlFor: "notify", children: "Notifications" }),
      /* @__PURE__ */ jsx(Switch, { id: "notify", children: /* @__PURE__ */ jsx(Switch.Thumb, { animation: "quick" }) })
    ] })
  ] });
}
export {
  LabelDemo
};
//# sourceMappingURL=LabelDemo.js.map
